import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Target,
  TrendingUp,
  Users,
  Shield,
  UsersRound,
  BookOpen,
  Code,
} from 'lucide-react'

const navigationItems = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'OKRs',
    path: '/okrs',
    icon: Target,
  },
  {
    name: 'Deal Pipeline',
    path: '/pipeline',
    icon: TrendingUp,
  },
  {
    name: 'Clients',
    path: '/clients',
    icon: Users,
  },
  {
    name: 'Compliance',
    path: '/compliance',
    icon: Shield,
  },
  {
    name: 'Team',
    path: '/team',
    icon: UsersRound,
  },
]

export default function Sidebar() {
  return (
    <aside className="w-64 bg-white border-r border-graphite-grey-100 flex flex-col shadow-sm">
      {/* Logo */}
      <div className="px-4 py-6 border-b border-graphite-grey-100">
        <a href="https://advisory.alliwanlabs.com/" className="block">
          <div className="bg-royal-blue-500 px-3 py-2 rounded-lg hover:bg-royal-blue-600 transition-colors cursor-pointer">
            <img 
              src="/logos/alliwan-text-logo.png" 
              alt="Al Liwan Group"
              className="w-full h-auto object-contain"
            />
          </div>
        </a>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-1">
        {navigationItems.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-link ${isActive ? 'nav-link-active' : ''}`
              }
            >
              <Icon className="w-5 h-5" />
              <span>{item.name}</span>
            </NavLink>
          )
        })}
      </nav>

      {/* Footer */}
      <div className="px-4 py-4 border-t border-graphite-grey-100 space-y-3">
        {/* Documentation Links */}
        <div className="space-y-1">
          <a
            href="/user-guide.html"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-3 py-2 text-xs text-graphite-grey-600 hover:text-royal-blue-600 hover:bg-pearl-white-100 rounded-lg transition-colors"
          >
            <BookOpen className="w-4 h-4" />
            <span>User Guide</span>
          </a>
          <a
            href="/PROJECT_DOCS.md"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-3 py-2 text-xs text-graphite-grey-600 hover:text-royal-blue-600 hover:bg-pearl-white-100 rounded-lg transition-colors"
          >
            <Code className="w-4 h-4" />
            <span>Technical Docs</span>
          </a>
        </div>

        {/* System Status */}
        <div className="bg-pearl-white-200 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-xs font-medium text-graphite-grey-700">System Status</span>
          </div>
          <p className="text-xs text-graphite-grey-500">All systems operational</p>
        </div>
      </div>
    </aside>
  )
}
